// Module
var code = "<div *ngIf=\"iconClass()\" class=\"acme-alert__prefix\">\n  <span class=\"acme-alert__icon\" [ngClass]=\"iconClass()\"></span>\n</div>\n<div class=\"acme-alert__content\">\n  <ng-content></ng-content>\n</div>\n";
// Exports
module.exports = code;